import React from 'react'
import ImageTestComp from '../components/ImageTestComp'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'


function ImageTest() {
    
  return (
    <>
    <Navbar />
    <ImageTestComp />
    <Footer />
    </>
  )
}

export default ImageTest